<template>
  <div>
    <loading v-if="loadingState" />
    <div class="container mt-5 mb-5">
      <div class="row justify-content-center">
        <div class="col-md-12 center mt-5">
          <h2 class="Bold">
            <b>ANAGRAFICA</b>
          </h2>
          <h5 class="black">
            Tutti i campi sono obbligatori e puoi modificare le celle di colore
            bianco.
          </h5>
          <p v-if="proccess == 'START'" class="black">
            In caso di variazione di email, partita iva o codice fiscale
            contatta il assistenza
          </p>
        </div>
      </div>

      <div class="row justify-content-center">
        <form
          v-if="proccess == 'START'"
          class="pb-5 black vaillantCont widthFull"
          id="registration-form"
        >
          <!-- ROW 0 ******************************************************************************************************* -->

          <div class="row mb-4 justify-content-center">
            <div class="col-md-12 mb-3">
              <h5 class="text-center pt-4">Logo della tua azienda</h5>
            </div>
            <div class="col-5 col-md-3 mb-3 pl-md-5 pr-md-5">
              <img v-if="logo" class="img-fluid" :src="logo" />
              <img
                v-else
                class="img-fluid"
                src="../../assets/images/DEFAULT_LOGO.png"
              />
            </div>

            <div class="col-md-4 mb-3">
              <div class="center" v-if="logo">
                Cambia Logo (formato: jpg, png)
              </div>
              <div class="center" v-else="logo">
                Carica Logo (formato: jpg, png)
              </div>
              <div class="front-image">
                <input
                  type="file"
                  v-on:change="uploadFile"
                  ref="fileInput"
                  name="invoiceFront"
                  id="invoiceFront"
                  class="fileInput"
                  data-vv-as="Logo"
                  v-validate="{
                    required: false,
                    size: 10240,
                    ext: ['jpeg', 'jpg', 'png'],
                    mimes: ['image/jpeg', 'image/jpg', 'image/png'],
                  }"
                  :class="{
                    'is-invalid': errors.has('invoiceFront'),
                    valid: !!invoiceFront,
                    helper: !!invoiceFrontBucket,
                  }"
                />

                <span class="highlight"></span>
                <span class="bar"></span>
                <label class="niceInputLabel labelFileInput" for="invoiceFront">
                  <span
                    v-if="!invoiceFrontName"
                    class="smallText center white"
                    :style="{
                      backgroundImage: 'url(' + invoiceFrontBucket + ')',
                    }"
                  >
                    <p
                      v-if="!invoiceFrontName"
                      class="smallText center white mt-3 mb-0 pb-0"
                    >
                      Scegli il Contratto quadro*
                    </p>
                  </span>

                  <span
                    v-else
                    class="smallText center white"
                    :style="{
                      backgroundImage: 'url(' + invoiceFrontBucket + ')',
                    }"
                  >
                  </span>
                </label>

                <div v-if="errors.has('invoiceFront')" class="invalid-feedback">
                  {{ errors.first("invoiceFront") }}
                </div>

                <div
                  v-if="uploadFrontPercentage"
                  class="progress"
                  id="progFront"
                >
                  <div
                    class="progress-bar"
                    id="progress-bar-front"
                    role="progressbar"
                    v-bind:style="{ width: uploadFrontPercentage + '%' }"
                    aria-valuenow="50"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    {{ uploadFrontPercentage }} %
                  </div>
                </div>

                <p
                  v-if="invoiceFrontName"
                  class="smallText center white mt-3 mb-0 pb-0 fileNameText"
                ></p>
              </div>

              <small v-if="!logo" class="pt-4 pl-3 pr-3 center">
                Il campo non è obbligatorio. Se carichi il logo potremo
                personalizzare i tuoi preventivi con il logo della tua azienda.
              </small>
            </div>
          </div>

          <!-- ROW 1 ******************************************************************************************************* -->

          <div class="row justify-content-center">
            <div class="col-md-6">
              <div class="group custInput">
                <input
                  type="text"
                  class="form-control"
                  v-model="azienda"
                  autocomplete="azienda"
                  id="azienda"
                  name="azienda"
                  data-vv-as="Ragione sociale"
                  v-validate="{ required: true, max: 128, min: 3 }"
                  :class="{
                    'is-invalid': errors.has('azienda'),
                    valid: !!azienda,
                  }"
                />
                <span class="highlight"></span>
                <span class="bar"></span>
                <label class="niceInputLabel" for="azienda"
                  >Ragione sociale *
                </label>
                <div v-if="errors.has('azienda')" class="invalid-feedback">
                  {{ errors.first("azienda") }}
                </div>
              </div>
            </div>

            <div class="col-md-3">
              <div class="group custInput">
                <input
                  type="text"
                  class="form-control disabled"
                  disabled
                  v-model="partita_iva"
                  autocomplete="partina-iva"
                  id="partita_iva"
                  name="partita_iva"
                  data-vv-as="Partita IVA"
                  v-validate="{
                    required: !codice_fiscale,
                    partitaIva: true,
                    max: 11,
                    min: 11,
                  }"
                  :class="{
                    'is-invalid': errors.has('partita_iva'),
                    valid: !!partita_iva,
                  }"
                />
                <span class="highlight"></span>
                <span class="bar"></span>
                <label class="niceInputLabel" for="partita_iva"
                  >Partita IVA *</label
                >

                <div
                  v-if="existPIVA"
                  class="invalid-feedback"
                  style="display: block"
                >
                  <span>Partita IVA inserita già presente.</span>
                </div>

                <div v-if="errors.has('partita_iva')" class="invalid-feedback">
                  {{ errors.first("partita_iva") }}
                </div>
              </div>
            </div>

            <div class="col-md-3">
              <div class="group custInput">
                <input
                  type="text"
                  class="form-control disabled"
                  v-model="codice_fiscale"
                  autocomplete="codice-fiscale"
                  id="codice_fiscale"
                  disabled
                  name="codice_fiscale"
                  data-vv-as="Codice Fiscale"
                  v-validate="{
                    required: !partita_iva,
                    codiceFiscale: true,
                    max: 16,
                    min: 16,
                  }"
                  :class="{
                    'is-invalid': errors.has('codice_fiscale'),
                    valid: !!codice_fiscale,
                  }"
                />
                <span class="highlight"></span>
                <span class="bar"></span>
                <label class="niceInputLabel" for="codice_fiscale"
                  >o Codice Fiscale *</label
                >

                <div
                  v-if="existCF"
                  class="invalid-feedback"
                  style="display: block"
                >
                  <span>Codice Fiscale inserito già presente.</span>
                </div>

                <div
                  v-if="errors.has('codice_fiscale')"
                  class="invalid-feedback"
                >
                  {{ errors.first("codice_fiscale") }}
                </div>
              </div>
            </div>
          </div>

          <!-- ROW 2 ******************************************************************************************************* -->

          <div class="row justify-content-center">
            <div class="col-md-2">
              <div class="group custInput">
                <input
                  type="text"
                  class="form-control disabled"
                  v-model="id_eps"
                  disabled
                  id="id_eps"
                  name="id_eps"
                  data-vv-as="Tipo Azienda"
                  v-validate="{}"
                  :class="{
                    'is-invalid': errors.has('id_eps'),
                    valid: !!id_eps,
                  }"
                />
                <span class="highlight"></span>
                <span class="bar"></span>
                <label class="niceInputLabel" for="id_eps">Tipo Azienda </label>
                <div v-if="errors.has('id_eps')" class="invalid-feedback">
                  {{ errors.first("id_eps") }}
                </div>
              </div>
            </div>

            <div
              v-if="
                id_eps == 'Ditta Individuale' ||
                id_eps == 'Professionista iscritto ad albi'
              "
              class="col-md-4 mb-3"
            >
              <div class="group custInput">
                <select
                  v-model="reg_forfettario"
                  autocomplete="randomy"
                  id="reg_forfettario"
                  :disabled="getProfile.reg_forfettario != '0'"
                  name="reg_forfettario"
                  class="form-control"
                  data-vv-as="Regime Forfettario"
                  v-validate="{ required: true }"
                  :class="{
                    'is-invalid': errors.has('reg_forfettario'),
                    valid: !!reg_forfettario,
                    disabled: getProfile.reg_forfettario != '0',
                  }"
                >
                  <option :key="911" value="si">si</option>
                  <option :key="912" value="no">no</option>
                </select>
                <span class="highlight"></span>
                <span class="bar"></span>
                <label class="niceInputLabel" for="region"
                  >Regime Forfettario *</label
                >

                <div
                  v-if="errors.has('reg_forfettario')"
                  class="invalid-feedback"
                >
                  {{ errors.first("reg_forfettario") }}
                </div>
              </div>
            </div>

            <div class="col-md-3">
              <div class="group custInput">
                <input
                  type="text"
                  class="form-control"
                  autocomplete="name"
                  v-model="name"
                  id="name"
                  name="name"
                  data-vv-as="Nome"
                  v-validate="{ required: true, max: 55, min: 2 }"
                  :class="{ 'is-invalid': errors.has('name'), valid: !!name }"
                />
                <span class="highlight"></span>
                <span class="bar"></span>
                <label class="niceInputLabel" for="name">Nome *</label>
                <div v-if="errors.has('name')" class="invalid-feedback">
                  {{ errors.first("name") }}
                </div>
              </div>
            </div>

            <div class="col-md-3">
              <div class="group custInput">
                <input
                  type="text"
                  class="form-control"
                  v-model="lastname"
                  autocomplete="lastname"
                  id="lastname"
                  name="lastname"
                  data-vv-as="Cognome"
                  v-validate="{ required: true, max: 55, min: 2 }"
                  :class="{
                    'is-invalid': errors.has('lastname'),
                    valid: !!lastname,
                  }"
                />
                <span class="highlight"></span>
                <span class="bar"></span>
                <label class="niceInputLabel" for="lastname">Cognome *</label>

                <div v-if="errors.has('lastname')" class="invalid-feedback">
                  {{ errors.first("lastname") }}
                </div>
              </div>
            </div>

            <div class="col-md-4 mb-4">
              <div class="group custInput">
                <input
                  type="text"
                  v-model="email"
                  autocomplete="email"
                  class="form-control disabled"
                  disabled
                  id="email"
                  name="email"
                  ref="email"
                  data-vv-as="Email"
                  v-validate="{
                    required: true,
                    email: true,
                    temporaryEmail: true,
                    plusIssueEmail: true,
                    max: 56,
                  }"
                  :class="{
                    'is-invalid': errors.has('email') || existEmail,
                    valid: !!email,
                  }"
                />
                <span class="highlight"></span>
                <span class="bar"></span>
                <label class="niceInputLabel" for="email">Email * </label>

                <div
                  v-if="existEmail"
                  class="invalid-feedback"
                  style="display: block"
                >
                  <span>Email digitato già presente</span>
                </div>
                <div v-if="errors.has('email')" class="invalid-feedback">
                  {{ errors.first("email") }}
                </div>
              </div>
            </div>
          </div>

          <!-- ROW 3 ******************************************************************************************************* -->

          <div class="row justify-content-center">
            <div class="col-md-3 mb-3">
              <div class="group custInput">
                <input
                  type="text"
                  class="form-control"
                  v-model="phone"
                  autocomplete="telefono"
                  id="phone"
                  name="phone"
                  data-vv-as="Telefono"
                  v-validate="{
                    required: true,
                    max: 12,
                    min: 8,
                    notZeros: true,
                    regex: /^[0,3]+/,
                  }"
                  :class="{ 'is-invalid': errors.has('phone'), valid: !!phone }"
                />
                <span class="highlight"></span>
                <span class="bar"></span>
                <label class="niceInputLabel" for="phone">Telefono * </label>
                <div v-if="errors.has('phone')" class="invalid-feedback">
                  {{ errors.first("phone") }}
                </div>
              </div>
            </div>

            <div class="col-md-3 mb-3">
              <div class="group custInput">
                <input
                  type="text"
                  class="form-control"
                  v-model="cellulare"
                  autocomplete="cellulare"
                  id="cellulare"
                  name="cellulare"
                  data-vv-as="Cellulare"
                  v-validate="{
                    required: true,
                    max: 12,
                    min: 8,
                    notZeros: true,
                    regex: /^[0,3]+/,
                  }"
                  :class="{
                    'is-invalid': errors.has('cellulare'),
                    valid: !!cellulare,
                  }"
                />
                <span class="highlight"></span>
                <span class="bar"></span>
                <label class="niceInputLabel" for="cellulare"
                  >Cellulare *
                </label>
                <div v-if="errors.has('cellulare')" class="invalid-feedback">
                  {{ errors.first("cellulare") }}
                </div>
              </div>
            </div>

            <div class="col-md-4 mb-3">
              <div class="group custInput">
                <input
                  type="text"
                  autocomplete="indirizzo"
                  class="form-control"
                  v-model="address"
                  id="address"
                  name="address"
                  data-vv-as="Indirizzo"
                  v-validate="{ required: true, max: 128, min: 5 }"
                  :class="{
                    'is-invalid': errors.has('address'),
                    valid: !!address,
                  }"
                />
                <span class="highlight"></span>
                <span class="bar"></span>
                <label class="niceInputLabel" for="address">Indirizzo *</label>
                <div v-if="errors.has('address')" class="invalid-feedback">
                  {{ errors.first("address") }}
                </div>
              </div>
            </div>
            <div class="col-md-2 mb-3">
              <div class="group custInput">
                <input
                  type="text"
                  autocomplete="civico"
                  class="form-control"
                  v-model="civic"
                  id="civic"
                  name="civic"
                  data-vv-as="Civico"
                  v-validate="{ required: true, max: 15 }"
                  :class="{ 'is-invalid': errors.has('civic'), valid: !!civic }"
                />
                <span class="highlight"></span>
                <span class="bar"></span>
                <label class="niceInputLabel" for="civic">Civico *</label>
                <div v-if="errors.has('civic')" class="invalid-feedback">
                  {{ errors.first("civic") }}
                </div>
              </div>
            </div>
          </div>

          <!-- ROW 4 ******************************************************************************************************* -->

          <div class="row justify-content-center">
            <div class="col-md-3 mb-3">
              <div class="group custInput">
                <select
                  v-model="region"
                  autocomplete="region-new"
                  id="region"
                  name="region"
                  class="form-control"
                  data-vv-as="Regione"
                  v-validate="{ required: true }"
                  :class="{
                    'is-invalid': errors.has('region'),
                    valid: !!region,
                  }"
                >
                  <option
                    v-for="region in regions"
                    :key="region.id_regione"
                    v-bind:value="{
                      id: region.id_regione,
                      text: region.regione,
                    }"
                    :selected="region.id_regione == shipData.region"
                  >
                    {{ region.regione }}
                  </option>
                </select>
                <span class="highlight"></span>
                <span class="bar"></span>
                <label class="niceInputLabel" for="region">Regione *</label>
                <div v-if="regionsState">
                  <font-awesome-icon
                    class="loadSpinner"
                    id="loadregion"
                    icon="spinner"
                    size="1x"
                    pulse
                  />
                </div>
                <div v-if="errors.has('region')" class="invalid-feedback">
                  {{ errors.first("region") }}
                </div>
              </div>
            </div>

            <div class="col-md-3 mb-3">
              <div class="group custInput">
                <select
                  v-model="province"
                  autocomplete="randomy"
                  id="province"
                  v-on:click="checkRegion"
                  name="province"
                  class="form-control"
                  data-vv-as="Provincia"
                  v-validate="{ required: true }"
                  :class="{
                    'is-invalid': errors.has('province'),
                    valid: !!province,
                  }"
                >
                  <option
                    v-for="province in provincies"
                    :key="province.sigla"
                    v-bind:value="province.sigla"
                    :selected="province.sigla == shipData.province"
                  >
                    {{ province.sigla }} - {{ province.provincia }}
                  </option>
                </select>
                <span class="highlight"></span>
                <span class="bar"></span>
                <label class="niceInputLabel" for="province"
                  >Provincia *<span v-if="provinceError" class="formError"
                    >Prima scegli Regione</span
                  ></label
                >
                <div v-if="provinciesState">
                  <font-awesome-icon
                    class="loadSpinner"
                    id="loadProvince"
                    icon="spinner"
                    size="1x"
                    pulse
                  />
                </div>
                <div v-if="errors.has('province')" class="invalid-feedback">
                  {{ errors.first("province") }}
                </div>
              </div>
            </div>

            <div class="col-md-3 mb-3">
              <div class="group custInput">
                <select
                  class="form-control"
                  autocomplete="randomu"
                  v-model="city"
                  v-on:click="checkProvince"
                  id="city"
                  name="city"
                  data-vv-as="Località"
                  v-validate="{ required: true }"
                  :disabled="citiesState"
                  :class="{ 'is-invalid': errors.has('city'), valid: !!city }"
                >
                  <option
                    v-for="city in cities"
                    :key="city.comune"
                    v-bind:value="{ cityistat: city.istat, city: city.comune }"
                    :selected="city.comune == shipData.city"
                  >
                    {{ city.comune }}
                  </option>
                </select>

                <span class="highlight"></span>
                <span class="bar"></span>
                <label class="niceInputLabel" for="city"
                  >Località *<span v-if="cityError" class="formError"
                    >Prima scegli Provincia</span
                  ></label
                >
                <div v-if="citiesState">
                  <font-awesome-icon
                    class="loadSpinner"
                    id="loadCity"
                    icon="spinner"
                    size="1x"
                    pulse
                  />
                </div>
                <div v-if="errors.has('city')" class="invalid-feedback">
                  {{ errors.first("city") }}
                </div>
              </div>
            </div>
            <div class="col-md-3 mb-3">
              <div class="group custInput">
                <select
                  class="form-control"
                  autocomplete="zip"
                  v-model="zip"
                  v-on:click="checkZip"
                  id="zip"
                  name="zip"
                  data-vv-as="Cap"
                  v-validate="{ required: true }"
                  :disabled="zipsState"
                  :class="{ 'is-invalid': errors.has('zip'), valid: !!zip }"
                >
                  <option
                    v-for="zip in zips"
                    :key="zip.cap"
                    v-bind:value="zip.cap"
                    :selected="zip.cap == shipData.zip"
                  >
                    {{ zip.cap }}
                  </option>
                </select>
                <span class="highlight"></span>
                <span class="bar"></span>
                <label class="niceInputLabel" for="zip"
                  >Cap *<span v-if="zipError" class="formError"
                    >Prima scegli Località</span
                  >
                </label>
                <div v-if="zipsState">
                  <font-awesome-icon
                    class="loadSpinner"
                    id="loadZips"
                    icon="spinner"
                    size="1x"
                    pulse
                  />
                </div>
                <div v-if="errors.has('zip')" class="invalid-feedback">
                  {{ errors.first("zip") }}
                </div>
              </div>
            </div>
          </div>

          <!-- DIVIDER -->
          <div class="row justify-content-center divider"></div>

          <!--<div class="row justify-content-center">

          <div class="col-md-12 mb-3 center">
            <h5 class="black center">I dati del conto corrente bancario</h5>
            <img v-if="getProfile.iban == ''" class="ptImage mr-3" src="../../assets/images/Poste.jpg"><small v-if="getProfile.iban == ''">Attenzione! Per usufruire del servizio è necessario inserire un <b>IBAN di Poste Italiane</b>. </small>
          </div>

          <div class="col-md-5 mb-3">
            <div class="group custInput">
              <input type="text" autocomplete="randomr" class="form-control" v-model="iban" id="iban" name="iban" data-vv-as="IBAN" :disabled="getProfile.iban != ''" v-validate="{ required:false, ibanControl: true, ibanItalian: true, ibanPoste: true,  max: 27, min: 27}"
                :class="{ 'is-invalid': errors.has('iban'), valid: !!iban, 'disabled': getProfile.iban != '' }">
              <span class="highlight"></span>
              <span class="bar"></span>
              <label class="niceInputLabel" for="iban">IBAN Poste Italiane</label>
              <div v-if="errors.has('iban')" class="invalid-feedback">
                {{ errors.first("iban") }}
              </div>
            </div>
          </div>

          <div class="col-md-7 mb-3">
            <div class="group custInput">
              <input type="text" autocomplete="randomr" class="form-control" v-model="ibanNome" id="ibanNome" name="ibanNome" :disabled="getProfile.intestatario != ''" data-vv-as="Nome intestatario" v-validate="{required:iban != '', max: 128, min: 5}"
                :class="{ 'is-invalid': errors.has('ibanNome'), valid: !!ibanNome, 'disabled': getProfile.intestatario != '' }">
              <span class="highlight"></span>
              <span class="bar"></span>
              <label class="niceInputLabel" for="ibanNome">Intestazione conto</label>
              <div v-if="errors.has('ibanNome')" class="invalid-feedback">
                {{ errors.first("ibanNome") }}
              </div>
            </div>
          </div>



        </div>-->

          <!-- DIVIDER -->
          <div class="row justify-content-center divider"></div>

          <div class="row justify-content-center">
            <div class="col-md-12 mb-3">
              <h5 class="black center">Modifica Password</h5>
            </div>
            <div class="col-md-4 mb-3">
              <div class="group custInput">
                <input
                  type="password"
                  class="form-control"
                  v-model="password"
                  autocomplete="new-password"
                  id="password"
                  name="password"
                  data-vv-as="Password"
                  v-validate="{ passwordCheck: true, min: 8, max: 56 }"
                  :class="{
                    'is-invalid': errors.has('password'),
                    valid: !!password,
                  }"
                />
                <span class="highlight"></span>
                <span class="bar"></span>
                <label class="niceInputLabel" for="password"
                  >Scegli nuova password *</label
                >
                <div v-if="errors.has('password')" class="invalid-feedback">
                  {{ errors.first("password") }}
                </div>
              </div>
            </div>
            <div class="col-md-4 mb-3">
              <div class="group custInput">
                <input
                  type="password"
                  class="form-control"
                  autocomplete="confirm-new-password"
                  v-model="confirm_password"
                  id="confirm_password"
                  name="confirm_password"
                  data-vv-as="Conferma Password"
                  v-validate="{
                    required: !!password,
                    passwordCheck: true,
                    min: 8,
                    max: 56,
                    confirmed: password,
                  }"
                  :class="{
                    'is-invalid': errors.has('confirm_password'),
                    valid: !!confirm_password,
                  }"
                />
                <span class="highlight"></span>
                <span class="bar"></span>
                <label class="niceInputLabel" for="confirm_password"
                  >Conferma nuova password *</label
                >
                <div
                  v-if="errors.has('confirm_password')"
                  class="invalid-feedback"
                >
                  {{ errors.first("confirm_password") }}
                </div>
              </div>
            </div>
          </div>

          <!-- DIVIDER -->
          <div class="row justify-content-center divider"></div>

          <div class="row justify-content-center">
            <div class="col-md-12 center mb-0 pt-4 mb-1">
              <button
                type="button"
                v-on:click="editUser('normal')"
                class="btn btn-lg btn-primary"
              >
                Salva
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import axios from "axios";
import { USER_REQUEST, USER_SET_DEFAULT_SHIP_DATA } from "actions/user";
import Datepicker from "vuejs-datepicker";
import { it } from "vuejs-datepicker/dist/locale";
import VueTimepicker from "vue2-timepicker";

const moment = require("moment");

export default {
  name: "play",
  components: {
    Datepicker,
    VueTimepicker,
  },
  data() {
    return {
      loadingState: false,
      proccess: "START",
      userToken: "",
      partita_iva: "",
      existPIVA: false,
      existEmail: false,
      existCF: false,
      tempIva: "",
      tempCF: "",
      tempEmail: "",
      azienda: "",
      name: "",
      lastname: "",
      email: "",
      phone: "",
      cellulare: "",
      codice_fiscale: "",
      shipEqual: true,
      shipData: {},
      address: "",
      civic: "",
      region: "",
      province: "",
      city: "",
      zip: "",
      regions: [],
      regionsState: true,
      provincies: [],
      provinciesState: false,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      provinceError: false,
      cityError: false,
      zipError: false,
      iban: "",
      ibanNome: "",
      ibanCognome: "",
      ship_regions: [],
      ship_regionsState: true,
      ship_provincies: [],
      ship_provinciesState: false,
      ship_cities: [],
      ship_citiesState: false,
      ship_zips: [],
      ship_zipsState: false,
      ship_provinceError: false,
      ship_cityError: false,
      ship_zipError: false,
      password: "",
      confirm_password: "",
      ship_name: "",
      ship_lastname: "",
      near: "",
      ship_phone: "",
      ship_cellulare: "",
      ship_address: "",
      ship_civic: "",
      ship_region: "",
      ship_province: "",
      ship_city: "",
      ship_zip: "",
      note: "",
      invoiceFront: "",
      invoiceFrontName: "",
      invoiceFrontBucket: "",
      uploadFrontPercentage: 0,
      invoiceRear: "",
      invoiceRearName: "",
      invoiceRearBucket: "",
      uploadRearPercentage: 0,
      id_eps: "",
      precompiled_iva: "",
      vw: window.innerWidth,
      logo: "",
      reg_forfettario: "",
    };
  },
  methods: {
    editUser(type) {
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.loadingState = true;
          var data = {
            user: {
              email: this.email,
              name: this.name,
              cognome: this.lastname,
              azienda: this.azienda,
              //id_eps: this.id_eps,
              indirizzo: this.address,
              civico: this.civic,
              comune: this.city.city,
              provincia: this.province,
              regione: this.region.text,
              cap: this.zip,
              telefono: this.phone,
              cellulare: this.cellulare,
              logo: this.saveDb,
              reg_forfettario: this.reg_forfettario,

              iban: this.iban,
              intestatario: this.ibanNome,
            },
            regType: this.precompiled_iva == this.partita_iva ? "old" : "new",
          };
          data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
          if (this.password != "" && this.confirm_password != "") {
            data.password = this.password;
          }

          axios({
            url: process.env.ROOT_API + "api/editUser",
            method: "POST",
            data: {
              data,
            },
            headers: {
              Authorization: "Bearer " + process.env.AUTH_TOKEN,
              "Content-type": "application/json",
            },
          })
            .then((resp) => {
              this.$store.dispatch(USER_REQUEST);

              if (type == "logo") {
              } else {
                this.addClientSuccess();
                this.$router.push("/");
              }

              //this.proccess = 'REG_SUCCESS'
              this.loadingState = false;
            })
            .catch((error) => {
              this.loadingState = false;
              var text = error.response.data.error;
              this.addClientError(text);
            });
        }
      });
    },
    uploadFile: function (input) {
      var file = input.target.files[0].name;
      this.invoiceFrontName = file;
      var extension = file.substr(file.lastIndexOf(".") + 1).toLowerCase();
      var size = input.target.files[0].size;
      if (
        (extension == "png" ||
          extension == "jpg" ||
          extension == "jpeg" ||
          extension == "pdf") &&
        size < 10240000
      ) {
        this.invoiceFront = input.target.files[0].name;
        var formData = new FormData();
        var _vue = this; // << here
        formData.append("fattura0", input.target.files[0]);
        axios
          .post(process.env.ROOT_API + "api/uploadImageInvoice", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + process.env.AUTH_TOKEN,
            },
            onUploadProgress: function (progressEvent) {
              this.uploadFrontPercentage = parseInt(
                Math.round((progressEvent.loaded * 100) / progressEvent.total)
              );
            }.bind(this),
          })
          .then(function (e) {
            var regex =
              /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
            if (regex.test(e.data.fattura)) {
              _vue.uploadFrontPercentage = 0;
              _vue.invoiceFrontBucket = e.data.fattura;
              _vue.saveDb = e.data.fatturaNoCrypt;
              _vue.logo = e.data.fattura;
              _vue.editUser("logo");
            } else {
              _vue.uploadFrontPercentage = 0;
              _vue.invoiceFront = "";
              _vue.invoiceFrontBucket = "";
              _vue.saveDb = "";
              _vue.UploadError();
              input.target.value = null;
            }
          })
          .catch(function () {
            _vue.uploadFrontPercentage = 0;
            _vue.invoiceFront = "";
            _vue.invoiceFrontBucket = "";
            _vue.saveDb = "";
            _vue.UploadError();
            input.target.value = null;
          });
      }
    },
    UploadError() {
      this.$swal({
        type: "error",
        title:
          '<strong class="modalText danger">Errore caricamento immagine</strong>',
        html: "",
        confirmButtonText: "CHIUDI",
        confirmButton: "closeProductsModal",
        confirmButtonColor: "#15267",
      });
    },
    async checkIfExistUser() {
      if (this.profile) {
        var data = this.profile;

        this.$log(data);

        this.codice_fiscale = data.codice_fiscale;
        this.partita_iva = data.partita_iva;
        this.email = data.email;
        this.azienda = data.azienda;
        this.address = data.indirizzo;
        this.civic = data.civico;
        this.phone = data.telefono;
        this.cellulare = data.cellulare;
        this.id_eps = data.tipo_azienda;

        this.name = data.name;
        this.lastname = data.cognome;

        this.logo = data.logo;

        this.iban = data.iban;
        this.ibanNome = data.intestatario;

        this.reg_forfettario =
          data.reg_forfettario == "0" ? "" : data.reg_forfettario;

        var _vue = this;

        _vue.$log("SET REGION");
        var regione = data.regione;
        await _vue.setRegion(regione);
        _vue.$log("SET REGION SUCCESS");

        setTimeout(async function () {
          _vue.$log("SET PROVINCE");
          var province = data.provincia;
          await _vue.setProvince(province);
          _vue.$log("SET PROVINCE SUCCESS");

          setTimeout(async function () {
            _vue.$log("SET CITY");
            var city = data.comune;
            await _vue.setCity(city);
            _vue.$log("SET CITY SUCCESS");

            setTimeout(async function () {
              _vue.$log("SET CAP");
              var cap = data.cap;
              await _vue.setCap(cap);
              _vue.$log("SET CAP SUCCESS");
            }, 1000);
          }, 1000);
        }, 1000);
      }
    },
    async setCap(cap) {
      for (var x in this.zips) {
        if (this.zips[x].cap == cap.toUpperCase()) {
          this.zip = this.zips[x].cap;
        }
      }
      this.$log(this.province);
    },
    async setCity(city) {
      for (var x in this.cities) {
        if (this.cities[x].comune == city.toUpperCase()) {
          var k = {
            cityistat: this.cities[x].istat,
            city: city.toUpperCase(),
          };
          this.city = k;
        }
      }
      this.$log(this.city);
    },
    async setProvince(province) {
      for (var x in this.provincies) {
        this.$log("START");
        this.$log(
          this.provincies[x].sigla + " =?= " + province.toUpperCase()
        );
        if (this.provincies[x].sigla == province.toUpperCase()) {
          this.province = this.provincies[x].sigla;
        }
      }
      this.$log(this.province);
    },
    async setRegion(regione) {
      for (var x in this.regions) {
        if (this.regions[x].regione == regione.toUpperCase()) {
          var k = {
            text: regione.toUpperCase(),
            id: this.regions[x].id_regione,
          };
          this.region = k;
        }
      }
      this.$log(this.region);
    },

    addClientSuccess() {
      this.$swal({
        type: "success",
        title:
          '<strong class="modalText ">I tuoi dati sono state salvati correttamente.</strong>',
        html: "",
        confirmButtonText: "CHIUDI",
        confirmButton: "closeProductsModal",
        confirmButtonColor: "#15267",
      });
    },

    addClientError(text) {
      this.$swal({
        type: "error",
        title:
          '<strong class="modalText danger">Operazione non andata a buon fine.</strong>',
        html: text,
        confirmButtonText: "CHIUDI",
        confirmButton: "closeProductsModal",
        confirmButtonColor: "#15267",
      });
    },

    async populateRegions() {
      await axios({
        url: process.env.ROOT_API + "api/getRegions",
        method: "POST",
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          this.regions = resp.data.regions;
          this.regionsState = false;

          this.ship_regions = resp.data.regions;
          this.ship_regionsState = false;
        })
        .catch((resp) => {
          this.regions = [];
          this.regionsState = false;

          this.ship_regions = [];
          this.ship_regionsState = false;
        });
    },

    checkRegion: function () {
      const { region } = this;
      if (region) {
        this.provinceError = false;
      } else {
        this.provinceError = true;
      }
    },
    checkProvince: function () {
      const { province } = this;
      if (province) {
        this.cityError = false;
      } else {
        this.cityError = true;
      }
    },
    checkZip: function () {
      const { city } = this;
      if (city) {
        this.zipError = false;
      } else {
        this.zipError = true;
      }
    },

    ship_checkRegion: function () {
      const { ship_region } = this;
      if (ship_region) {
        this.ship_provinceError = false;
      } else {
        this.ship_provinceError = true;
      }
    },
    ship_checkProvince: function () {
      const { ship_province } = this;
      if (ship_province) {
        this.ship_cityError = false;
      } else {
        this.ship_cityError = true;
      }
    },
    ship_checkZip: function () {
      const { ship_city } = this;
      if (ship_city) {
        this.ship_zipError = false;
      } else {
        this.ship_zipError = true;
      }
    },

    calcToDate() {
      var start = process.env.START_DATE;
      var date = new Date(new Date().setDate(new Date().getDate() - 5));
      var startDate = new Date(start.year, start.month - 1, start.day);
      if (startDate > date) {
        var finalTo = startDate;
      } else {
        var finalTo = date;
      }
      return finalTo;
    },
    calcFromDate() {
      var stopObj = process.env.STOP_DATE;
      var stopDate = new Date(stopObj.year, stopObj.month - 1, stopObj.day + 1);
      var nowDate = new Date();
      if (nowDate <= stopDate) {
        var finalFrom = nowDate;
      } else {
        var finalFrom = stopDate;
      }
      return finalFrom;
    },

    handleResize: function () {
      this.vw = window.innerWidth;
    },
  },
  watch: {
    iban: function (value) {
      if(value){
        this.iban = value.toUpperCase().trim();
      this.iban = this.iban.replace(" ", "");
      }
      
    },
    azienda: function (value) {
      this.azienda = value.toUpperCase();
    },
    name: function (value) {
      this.name = value.toUpperCase();
    },
    lastname: function (value) {
      this.lastname = value.toUpperCase();
    },
    ship_name: function (value) {
      this.ship_name = value.toUpperCase();
    },
    ship_lastname: function (value) {
      this.ship_lastname = value.toUpperCase();
    },
    number: function (value) {
      this.number = parseInt(value);
    },
    phone: function (val) {
      if (val) {
        this.phone = val.replace(/\D+/g, "");
      }
    },
    id_eps: function (val) {
      if (val) {
        //this.id_eps = val.replace(/\D+/g, '');
      }
    },
    cellulare: function (val) {
      if (val) {
        this.cellulare = val.replace(/\D+/g, "");
      }
    },
    ship_phone: function (val) {
      if (val) {
        this.ship_phone = val.replace(/\D+/g, "");
      }
    },
    ship_cellulare: function (val) {
      if (val) {
        this.ship_cellulare = val.replace(/\D+/g, "");
      }
    },
    region: async function (newVal) {
      this.zips = [];
      this.cities = [];
      this.zip = "";
      this.city = "";
      this.cityError = false;
      this.provinceError = false;
      this.zipError = false;
      this.province = "";
      this.provincies = [];
      this.provinciesState = true;

      const { provincies, provinciesState } = this;
      await axios({
        url: process.env.ROOT_API + "api/getProvincies",
        method: "POST",
        data: {
          region: newVal.id,
        },
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          this.provincies = resp.data.provincies;
          this.provinciesState = false;
        })
        .catch((resp) => {
          this.provincies = [];
          this.provinciesState = false;
        });
    },
    ship_region: function (newVal) {
      this.ship_zips = [];
      this.ship_cities = [];
      this.ship_zip = "";
      this.ship_city = "";
      this.ship_cityError = false;
      this.ship_provinceError = false;
      this.ship_zipError = false;
      this.ship_province = "";
      this.ship_provincies = [];
      this.ship_provinciesState = true;

      const { ship_provincies, ship_provinciesState } = this;
      axios({
        url: process.env.ROOT_API + "api/getProvincies",
        method: "POST",
        data: {
          region: newVal.id,
        },
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          this.ship_provincies = resp.data.provincies;
          this.ship_provinciesState = false;
        })
        .catch((resp) => {
          this.ship_provincies = [];
          this.ship_provinciesState = false;
        });
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    province: function (newProvince) {
      this.zips = [];
      this.cities = [];
      this.zip = "";
      this.city = "";
      this.cityError = false;
      this.zipError = false;

      if (newProvince) {
        this.citiesState = true;
        axios({
          url: process.env.ROOT_API + "api/getComuni",
          method: "POST",
          data: {
            provincia: newProvince,
          },
          headers: {
            Authorization: "Bearer " + process.env.AUTH_TOKEN,
            "Content-type": "application/json",
          },
        })
          .then((resp) => {
            this.cities = resp.data.cities;
            this.citiesState = false;
          })
          .catch((resp) => {
            this.cities = [];
            this.citiesState = false;
          });
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    ship_province: function (newProvince) {
      this.ship_zips = [];
      this.ship_cities = [];
      this.ship_zip = "";
      this.ship_city = "";
      this.ship_cityError = false;
      this.ship_zipError = false;

      if (newProvince) {
        this.ship_citiesState = true;
        axios({
          url: process.env.ROOT_API + "api/getComuni",
          method: "POST",
          data: {
            provincia: newProvince,
          },
          headers: {
            Authorization: "Bearer " + process.env.AUTH_TOKEN,
            "Content-type": "application/json",
          },
        })
          .then((resp) => {
            this.ship_cities = resp.data.cities;
            this.ship_citiesState = false;
          })
          .catch((resp) => {
            this.ship_cities = [];
            this.ship_citiesState = false;
          });
      }
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    city: function (newCity) {
      this.zipError = false;
      this.zips = [];
      this.zip = "";

      if (newCity.cityistat) {
        this.zipsState = true;
        axios({
          url: process.env.ROOT_API + "api/getCap",
          method: "POST",
          data: {
            istat: newCity.cityistat,
          },
          headers: {
            Authorization: "Bearer " + process.env.AUTH_TOKEN,
            "Content-type": "application/json",
          },
        })
          .then((resp) => {
            this.zips = resp.data.zips;
            this.zipsState = false;
          })
          .catch((resp) => {
            this.zips = [];
            this.zipsState = false;
          });
      }
    },
    async getProfile() {
      await this.checkIfExistUser();
    },
    // IF CHANGE PROVINCE -> LOAD CITIES
    ship_city: function (newCity) {
      this.ship_zipError = false;
      this.ship_zips = [];
      this.ship_zip = "";

      if (newCity.cityistat) {
        this.ship_zipsState = true;
        axios({
          url: process.env.ROOT_API + "api/getCap",
          method: "POST",
          data: {
            istat: newCity.cityistat,
          },
          headers: {
            Authorization: "Bearer " + process.env.AUTH_TOKEN,
            "Content-type": "application/json",
          },
        })
          .then((resp) => {
            this.ship_zips = resp.data.zips;
            this.ship_zipsState = false;
          })
          .catch((resp) => {
            this.ship_zips = [];
            this.ship_zipsState = false;
          });
      }
    },
    vw: function () {},
  },
  updated: function () {},
  created: function () {
    this.$validator.extend("notZeros", {
      getMessage: (field) =>
        " Il campo Numero di telefono non ha un formato valido.",
      validate: (value) => {
        // value must be > zero
        if (
          value > 1000000 &&
          value.length > 1 &&
          value != 30000000 &&
          value != 300000000 &&
          value != 3000000000 &&
          value != 30000000000
        )
          return true;
        return false;
      },
    });
  },
  async mounted() {
    var _vue = this;
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    await this.populateRegions(), (this.lastnamex = this.getProfile.cognome);
    this.xuserx = this.getProfile.name;

    if (this.getProfile) {
      await this.checkIfExistUser();
    }

    setTimeout(function () {
      _vue.disabledDates = {
        to: _vue.calcToDate(), // Disable all dates up to specific date
        from: _vue.calcFromDate(), // Disable all dates after specific date
      };

      _vue.scrollFinished = true;
    }, 1500);
  },
  computed: {
    ...mapGetters(["getProfile", "isAuthenticated", "isProfileLoaded"]),
    ...mapState({
      profile: (state) => state.user.profile,
    }),
  },
};
</script>

<style lang="scss" scoped>
$phone: 667px;
$tablet: 1024px;
$desktop: 1324px;
$lgscreen: 1524px;

.fileNameText {
  position: absolute;
  bottom: -37px;
  font-size: 17px;
  width: 100%;
  text-align: center;
  color: #0e3d8b !important;
  z-index: 12313;
  white-space: nowrap;
  word-wrap: break-word;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.borderTop {
  border-top: 3px solid #003d13;
  padding-top: 15px;
}

.shopIcon {
  width: 75px;
}

.bigTitle {
  font-size: 47px;
  color: #003d13;

  @media screen and (max-width: $phone) {
    font-size: 27px;
  }
}

.hideFileUpload {
  position: absolute;
  width: 100%;
  height: 110%;
  background: #000000;
  opacity: 0.4;
  top: -18px;
  left: 0;
  filter: blur(24px);
  z-index: 10000;
}

h5 {
  @media screen and (max-width: $phone) {
    font-size: 14px;
  }
}
.corporateImg {
  max-height: 153px;
}
.backImageInvoice {
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  text-align: center;
  > img {
    max-height: 477px;
    margin: 0 auto;
    cursor: pointer;
  }
}

.zoomImage {
  position: absolute;
  left: 48%;
  top: 230px;
  cursor: pointer;
}

.vcenter {
  align-items: center;
  align-self: center;
  vertical-align: middle;
  display: inherit;
}

.front-image {
  position: relative;
  margin: 0 auto;
  display: block;
  height: 147px;
  text-align: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-item-align: center;
  align-self: center;
  width: 191px;
  margin-bottom: 17px;

  @media screen and (max-width: $tablet) {
    margin-top: 15px !important;
  }

  > .fileInputLabel {
    display: none;
  }

  > .invalid-feedback {
    display: block;
    position: absolute;
    bottom: 15px;
    font-weight: 800;
  }

  > input {
    position: absolute;
    filter: alpha(opacity=0);
    opacity: 0;
    left: 5px;
    width: 100%;
    height: 200px;
    z-index: 10;
    top: -20px;
  }

  > label {
    /*display: none;*/

    width: 100%;
    margin: 0 auto;
    text-align: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-item-align: center;
    align-self: center;
    position: relative;
    padding: 0!important !important;
    left: 0;

    > span {
      background-color: #dee6ff;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      border: 1px solid white;
      width: 192px;
      margin-top: 19px !important;
      display: block;
      height: 155px;
      margin: 0 auto;
      cursor: pointer;
      word-break: break-all;
      padding: 5px;
      color: white;
      border-radius: 7px;
      overflow-wrap: break-word;
      white-space: normal;
      line-height: 29px;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      align-self: center;
      vertical-align: middle;
      margin: auto;
      display: inline-grid;
      background-size: cover;
      background-position: center;

      &:before {
        content: "+";
        display: block;
        clear: both;
        text-align: center;
        height: 141px;
        width: 179px;
        border-radius: 7px;
        padding-top: 51px;
        font-size: 51px;
        font-weight: 600;
        color: #0091da;
        border: 3px solid #0091da;
      }

      @media screen and (max-width: $phone) {
        margin: 0 auto!important !important;
        float: none;
      }
      @media screen and (min-width: $phone) and (max-width: $tablet) {
        margin: 0 auto!important !important;
        float: none;
      }
    }

    &:after {
      content: "";
      display: block;

      clear: both;
      text-align: center;
      width: 237px;
      font-size: 10px;
      text-decoration: underline;
      color: black;

      /*
      display: block;
clear: both;
text-align: center;
height: 188px;
width: 188px;
border-radius: 7px;
font-size: 10px;
text-decoration: underline;
color: black;
border: 3px solid #0e3d8b;*/

      @media screen and (max-width: $phone) {
        margin: 0 auto!important !important;
        float: none;
      }
      @media screen and (min-width: $phone) and (max-width: $tablet) {
        margin: 0 auto!important !important;
        float: none;
      }
    }

    @media screen and (max-width: $phone) {
      width: 100% !important;
      float: none !important;
      text-align: center !important;
      margin: 0 auto!important !important;
    }
    @media screen and (min-width: $phone) and (max-width: $tablet) {
      width: 100% !important;
      float: none !important;
      text-align: center !important;
      margin: 0 auto!important !important;
    }
  }
}

.center-container {
  display: flex;
  align-items: center;
  flex-direction: column;
}
</style>


<style lang="css" scoped>
.sweetText {
  font-size: 26px;
}
.imageIcons {
  vertical-align: bottom !important;
  width: 50px;
}

.hSize {
  font-size: 33px !important;
}

.howPlayTextCont[data-v-54f59cc7] {
  max-width: 333px;
  text-align: left;
  margin: 0 auto;
  line-height: 27px;
  padding-left: 61px;
}

/* new PRICE */

.swal2-popup .swal2-title,
#swal2-content {
  color: #fffbde !important;
  display: block !important;
}

.replaceButton {
  max-width: 40px;
}

.inputHelper {
  margin-top: -32px;
  color: #0e3d8b;
  font-size: 16px;
  left: 0;
}

.priceVal,
.priceCent {
  width: calc(50% - 1.5vw - 7.5px);
  display: inline-table;
}

.pseudoEuro {
  position: absolute;
  top: 6px;
}
.pseudoCent {
  position: absolute;
  top: 6px;
  right: 0;
}

.group input:focus + .pseudoEuro {
  display: block;
}

.group .valid + .pseudoEuro {
  display: block;
}

.group input:focus + .pseudoCent {
  display: block;
}

.group .valid + .pseudoCent {
  display: block;
}

.euroInput {
  position: relative;
  width: 200%;
  z-index: 4;
}

.euroInput::before {
  content: "Euro";
}

.euroInput:focus,
.euroInput.valid {
  width: 100%;
}

.euroInput:focus::before,
.euroInput.valid::before {
  content: "Euro";
  color: white;
  position: absolute;
}

.table {
  display: table;
}

.newPriceLabel {
  z-index: 5;
  background: white;
  margin-left: -5px;
  padding-left: 5px;
  overflow: initial;
  min-width: calc(200% + 17px);
}

/*  ------------ */

.image-margin0 {
  margin: 0 !important;
}

.helper {
  color: #0e3d8b;
  font-size: 23px;
  font-family: Oswald-Medium;
}

.greyDesc2 {
  font-size: 1.1vw;
  color: #fffbde;
}

.redDesc {
  font-size: 1.1vw;
  text-decoration: underline;
  cursor: pointer;
}

.uploadDone {
  position: absolute;
  top: 10px;
  right: 0;
  color: #a1614f;
}

.helperUnderline {
}

.labelFileInput {
  top: -20px !important;
  font-size: 22px;
  color: #000000;
}

.fileInput {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  padding: 0;
  top: 17px;
  border-bottom: none;
  color: #000000;
}

.fileInputLabel {
  z-index: 3;
  white-space: nowrap;
  overflow: hidden;
  padding-right: 20px;
  text-overflow: ellipsis;
  color: #fffbde;
}

.removeProduct {
  position: absolute;
  right: 21px;
  margin: 0px !important;
  top: 48px;
  color: #e7201d;
}

.typeDisabled {
  color: #676767;
  cursor: pointer;
}

.typeSelected {
  color: #fffbde !important;
  cursor: pointer;
}

@media (min-width: 20px) and (max-width: 767px) {
  .inputHelper {
    margin-top: -12px;
    color: #0e3d8b;
    font-size: 16px;
    left: 0;
  }

  .hSize {
    font-size: 19px !important;
  }
  .sweetText {
    font-size: 19px;
  }
  .removeProduct {
    position: absolute;
    right: 21px;
    margin: 0px !important;
    top: 26px;
    color: #e7201d;
  }

  .greyDesc2,
  .redDesc {
    font-size: 3.1vw;
  }

  .fluid {
    max-width: 107px;
  }

  .mobTQ {
    font-size: 23px;
  }

  .smMob {
    font-size: 1rem;
  }

  .howPlayTextCont[data-v-54f59cc7][data-v-54f59cc7] {
    max-width: 350px;
    text-align: left;
    margin: 0 auto;
    line-height: 27px;
    padding-left: 43px;
    font-size: 17px;
  }

  .helper {
    color: #0e3d8b;
    font-size: 18px;
    font-family: Oswald-Medium;
  }
  .imageIcons {
    vertical-align: bottom !important;
    width: 39px;
  }
  .fileInput {
    top: 8px !important;
  }
}

@media (min-width: 768px) and (max-width: 1205px) {
  .disabledDatesMessage {
    top: -250%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/hoval.vue